import comp from "./DisplaySettingsModal";
export default comp;
